/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Component } from '@angular/core';
import { ApiService } from './../../services/api.service';

@Component({
  selector: 'left-menu', // <my-app></my-app>
  template: require('./leftMenu.html')
})
export class LeftMenu {

  public listCategorias = [];

  constructor(private _apiService: ApiService) {
    this._apiService.getAllCategory().subscribe(
      result=>{
        this.listCategorias = result;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/leftMenu/leftMenu.component.ts